import React from "react";

export const RenderStepInputReadonlyField = (label: string, value: any, unit?: string) => {
    return <div className="step-input-field-container">
        <div className="step-input-field">
            <div className="label">
                {__(label)}
            </div>
            <div className="text-field--readonly">
                {value} {unit && <span className="unit-label--readonly">{unit}</span>}
            </div>
        </div>
    </div>
}